module.exports = __webpack_public_path__ + "static/media/wicket6.79055341.png";